import React, { Component } from "react";
import CartContext from "../StoreManager/CartContext";
import {
  Accordion,
  Table,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Alert,
  Spinner,
} from "react-bootstrap";

/* ---------- ReservationModal (unchanged from prior) ---------- */
// ... include the ReservationModal class from previous full file (identical) ...
// For brevity I will include the same ReservationModal implementation used earlier.

class ReservationModal extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      local: this.mapPropsToState(props.item),
      saving: false,
      error: null,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!nextProps.item && prevState.local && prevState.local._source) {
      return { local: ReservationModal.emptyReservation(nextProps) };
    }
    if (
      nextProps.item &&
      (!prevState.local ||
        prevState.local._source !== nextProps.item.reservationId)
    ) {
      return { local: ReservationModal.mapItem(nextProps.item) };
    }
    return null;
  }

  static emptyReservation(props = {}) {
    const storeId = (props && props.storeId) || "";
    return {
      _source: null,
      reservationNo: "",
      guestId: "",
      statusId: "",
      arrivalDate: "",
      departureDate: "",
      numRooms: 1,
      numGuests: 1,
      totalAmount: 0,
      notes: "",
      storeId,
    };
  }

  static mapItem(item) {
    if (!item) return ReservationModal.emptyReservation();
    return {
      _source: item.reservationId,
      reservationNo: item.reservationNo || "",
      guestId: item.guestId || "",
      statusId: item.statusId || "",
      arrivalDate: item.arrivalDate ? item.arrivalDate.split("T")[0] : "",
      departureDate: item.departureDate ? item.departureDate.split("T")[0] : "",
      numRooms: item.numRooms || 1,
      numGuests: item.numGuests || 1,
      totalAmount: item.totalAmount || 0,
      notes: item.notes || "",
      storeId: item.storeId || "",
    };
  }

  mapPropsToState = (item) =>
    item
      ? ReservationModal.mapItem(item)
      : ReservationModal.emptyReservation(this.props);

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((s) => ({ local: { ...s.local, [name]: value } }));
  };

  save = async () => {
    const { onSave } = this.props;
    const { local } = this.state;

    if (!local.arrivalDate || !local.departureDate) {
      this.setState({ error: "Arrival and Departure dates are required." });
      return;
    }
    if (new Date(local.departureDate) <= new Date(local.arrivalDate)) {
      this.setState({ error: "Departure must be after Arrival." });
      return;
    }

    const payload = {
      reservationNo: local.reservationNo || null,
      guestId: local.guestId || null,
      statusId: local.statusId || null,
      arrivalDate: local.arrivalDate,
      departureDate: local.departureDate,
      numRooms: Number(local.numRooms) || 1,
      numGuests: Number(local.numGuests) || 1,
      totalAmount: Number(local.totalAmount) || 0,
      notes: local.notes || null,
    };

    this.setState({ saving: true, error: null });
    try {
      await onSave(payload, !!local._source);
      this.setState({ saving: false, error: null });
    } catch (err) {
      this.setState({ saving: false, error: err.message || String(err) });
    }
  };

  render() {
    const { show, onClose, guests = [], statuses = [] } = this.props;
    const { local, saving, error } = this.state;

    return (
      <Modal show={show} onHide={onClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {local && local._source ? "Edit Reservation" : "New Reservation"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Guest</Form.Label>
                  <Form.Select
                    name="guestId"
                    value={local.guestId}
                    onChange={this.handleChange}
                  >
                    <option value="">-- Select Guest --</option>
                    {guests.map((g) => (
                      <option key={g.guestId} value={g.guestId}>
                        {g.firstName} {g.lastName}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    name="statusId"
                    value={local.statusId}
                    onChange={this.handleChange}
                  >
                    <option value="">-- Select --</option>
                    {statuses.map((s) => (
                      <option
                        key={s.reservationStatusId}
                        value={s.reservationStatusId}
                      >
                        {s.code}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Arrival Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="arrivalDate"
                    value={local.arrivalDate}
                    onChange={this.handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Departure Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="departureDate"
                    value={local.departureDate}
                    onChange={this.handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Rooms</Form.Label>
                  <Form.Control
                    type="number"
                    name="numRooms"
                    value={local.numRooms}
                    onChange={this.handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Guests</Form.Label>
                  <Form.Control
                    type="number"
                    name="numGuests"
                    value={local.numGuests}
                    onChange={this.handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Total Amount</Form.Label>
                  <Form.Control
                    type="number"
                    name="totalAmount"
                    value={local.totalAmount}
                    onChange={this.handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name="notes"
                value={local.notes}
                onChange={this.handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.save} disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

/* ---------- RoomsModal (unchanged from prior) ---------- */
/* Reuse the RoomsModal implementation provided earlier (keeps search, add selected rooms, auto-allocate, etc.). */

class RoomsModal extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      roomNew: this.emptyRoom(),
      reservationRooms: [],
      availableRooms: [],
      availableLoading: false,
      availableError: null,
      selectedRoomIds: new Set(),
      addingRooms: false,
      loadingRooms: false,
      availabilitySearched: false,
    };
  }

  emptyRoom = () => ({
    roomTypeId: "",
    roomId: "",
    ratePlanId: "",
    ratePerNight: 0,
    fromDate: "",
    toDate: "",
    nights: 1,
    amount: 0,
    guestFirstName: "",
    guestLastName: "",
  });

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      this.loadReservationRooms();
      this.setState({
        roomNew: this.emptyRoom(),
        availableRooms: [],
        selectedRoomIds: new Set(),
        availableError: null,
        availabilitySearched: false,
      });
    }
    if (
      this.props.reservationId &&
      prevProps.reservationId !== this.props.reservationId
    ) {
      this.loadReservationRooms();
    }
  }

  apiUrl = (resource) => {
    if (this.props.apiUrl) return this.props.apiUrl(resource);
    const baseRaw = process.env.REACT_APP_API || "";
    const base =
      baseRaw.replace(/\/+$/, "") ||
      `${window.location.origin.replace(/\/+$/, "")}/api`;
    const path = resource.replace(/^\/+/, "");
    const storeId = this.context?.storeId;
    return storeId
      ? `${base}/${path}?storeId=${encodeURIComponent(storeId)}`
      : `${base}/${path}`;
  };

  fetchWithAuth = async (url, opts = {}) => {
    if (this.props.fetchWithAuth) return this.props.fetchWithAuth(url, opts);
    const headers = { ...(opts.headers || {}) };
    if (
      opts.body &&
      !(opts.body instanceof FormData) &&
      !headers["Content-Type"]
    )
      headers["Content-Type"] = "application/json";
    const token = this.context?.authToken;
    if (token) headers["Authorization"] = `Bearer ${token}`;
    return fetch(url, { ...opts, headers });
  };

  loadReservationRooms = async () => {
    const { reservationId } = this.props;
    if (!reservationId) return;
    this.setState({ loadingRooms: true, availableError: null });
    try {
      const url = this.apiUrl(`HotelReservation/${reservationId}/rooms`);
      const res = await this.fetchWithAuth(url);
      if (!res.ok) {
        const txt = await res.text().catch(() => res.statusText);
        throw new Error(`${res.status} ${txt}`);
      }
      const rooms = await res.json();
      this.setState({ reservationRooms: rooms });
    } catch (err) {
      console.error("loadReservationRooms", err);
      this.setState({
        availableError: err.message || "Failed to load reservation rooms.",
      });
    } finally {
      this.setState({ loadingRooms: false });
    }
  };

  handleRoomNewChange = (e) => {
    const { name, value } = e.target;
    this.setState((s) => ({ roomNew: { ...s.roomNew, [name]: value } }));
    if (name === "roomTypeId" || name === "fromDate" || name === "toDate") {
      this.setState({
        availableRooms: [],
        selectedRoomIds: new Set(),
        availabilitySearched: false,
        availableError: null,
      });
    }
  };

  searchAvailability = async () => {
    const { roomNew } = this.state;
    const reservationId = this.props.reservationId;
    if (!roomNew.roomTypeId || !roomNew.fromDate || !roomNew.toDate) {
      this.setState({
        availableError: "Please select Room Type and From/To dates.",
      });
      return;
    }
    const base = this.apiUrl(
      `HotelReservation/${encodeURIComponent(reservationId)}/available-rooms`
    );
    const sep = base.includes("?") ? "&" : "?";
    const url = `${base}${sep}roomTypeId=${encodeURIComponent(
      roomNew.roomTypeId
    )}&from=${encodeURIComponent(roomNew.fromDate)}&to=${encodeURIComponent(
      roomNew.toDate
    )}`;

    this.setState({ availableLoading: true, availableError: null });
    try {
      const res = await this.fetchWithAuth(url);
      if (!res.ok) {
        const txt = await res.text().catch(() => res.statusText);
        throw new Error(`${res.status} ${txt}`);
      }
      const list = await res.json();
      this.setState({ availableRooms: list || [], availabilitySearched: true });
    } catch (err) {
      console.error("searchAvailability", err);
      this.setState({
        availableError: err.message || "Failed to fetch available rooms.",
        availableRooms: [],
        availabilitySearched: true,
      });
    } finally {
      this.setState({ availableLoading: false });
    }
  };

  toggleSelectRoom = (roomId) => {
    this.setState((prev) => {
      const set = new Set(prev.selectedRoomIds);
      if (set.has(roomId)) set.delete(roomId);
      else set.add(roomId);
      return { selectedRoomIds: set };
    });
  };

  addSelectedRooms = async () => {
    const { selectedRoomIds, roomNew } = this.state;
    const { reservationId, onAdded } = this.props;
    if (!reservationId) {
      this.setState({ availableError: "Reservation not selected." });
      return;
    }
    if (!selectedRoomIds || selectedRoomIds.size === 0) {
      this.setState({
        availableError:
          "No rooms selected. You can auto-allocate by type instead.",
      });
      return;
    }

    this.setState({ addingRooms: true, availableError: null });
    try {
      const calls = Array.from(selectedRoomIds).map((rid) => {
        const payload = {
          roomTypeId: roomNew.roomTypeId,
          roomId: rid,
          ratePlanId: roomNew.ratePlanId || null,
          ratePerNight: Number(roomNew.ratePerNight) || 0,
          fromDate: roomNew.fromDate,
          toDate: roomNew.toDate,
          nights: Number(roomNew.nights) || 1,
          amount: Number(roomNew.amount) || 0,
          guestFirstName: roomNew.guestFirstName || null,
          guestLastName: roomNew.guestLastName || null,
        };
        const url = this.apiUrl(`HotelReservation/${reservationId}/rooms`);
        return this.fetchWithAuth(url, {
          method: "POST",
          body: JSON.stringify(payload),
        }).then(async (res) => {
          if (!res.ok) {
            const txt = await res.text().catch(() => res.statusText);
            throw new Error(`Add room failed: ${res.status} ${txt}`);
          }
          return res.json().catch(() => null);
        });
      });

      await Promise.all(calls);
      await this.loadReservationRooms();
      if (onAdded) await onAdded();
      this.setState({ selectedRoomIds: new Set(), availableRooms: [] });
    } catch (err) {
      console.error("addSelectedRooms", err);
      this.setState({ availableError: err.message || "Failed to add rooms." });
    } finally {
      this.setState({ addingRooms: false });
    }
  };

  autoAllocateByType = async () => {
    const { roomNew } = this.state;
    const { reservationId, onAdded } = this.props;
    const url = this.apiUrl(`HotelReservation/${reservationId}/rooms`);
    const payload = {
      roomTypeId: roomNew.roomTypeId,
      roomId: null,
      ratePlanId: roomNew.ratePlanId || null,
      ratePerNight: Number(roomNew.ratePerNight) || 0,
      fromDate: roomNew.fromDate,
      toDate: roomNew.toDate,
      nights: Number(roomNew.nights) || 1,
      amount: Number(roomNew.amount) || 0,
      guestFirstName: roomNew.guestFirstName || null,
      guestLastName: roomNew.guestLastName || null,
    };

    this.setState({ addingRooms: true, availableError: null });
    try {
      const res = await this.fetchWithAuth(url, {
        method: "POST",
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const txt = await res.text().catch(() => res.statusText);
        throw new Error(`${res.status} ${txt}`);
      }
      await this.loadReservationRooms();
      if (onAdded) await onAdded();
    } catch (err) {
      console.error("autoAllocateByType", err);
      this.setState({ availableError: err.message || "Failed to add room." });
    } finally {
      this.setState({ addingRooms: false });
    }
  };

  deleteReservationRoom = async (reservationRoomId) => {
    const { reservationId, onAdded } = this.props;
    if (!reservationId || !reservationRoomId) return;
    if (!window.confirm("Delete reservation room line?")) return;
    try {
      const url = this.apiUrl(
        `HotelReservation/${reservationId}/rooms/${reservationRoomId}`
      );
      const res = await this.fetchWithAuth(url, { method: "DELETE" });
      if (!res.ok) {
        const txt = await res.text().catch(() => res.statusText);
        throw new Error(`${res.status} ${txt}`);
      }
      await this.loadReservationRooms();
      if (onAdded) await onAdded();
    } catch (err) {
      console.error("deleteReservationRoom", err);
      this.setState({
        availableError: err.message || "Failed to delete reservation room.",
      });
    }
  };

  render() {
    const { show, onClose, roomTypes = [], ratePlans = [] } = this.props;
    const {
      roomNew,
      reservationRooms,
      availableRooms,
      availableLoading,
      availableError,
      selectedRoomIds,
      addingRooms,
      loadingRooms,
      availabilitySearched,
    } = this.state;

    return (
      <Modal show={show} onHide={onClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Reservation Rooms</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {availableError && <Alert variant="danger">{availableError}</Alert>}
          {loadingRooms ? (
            <div className="d-flex align-items-center">
              <Spinner animation="border" size="sm" className="me-2" /> Loading
              rooms...
            </div>
          ) : (
            <Table bordered hover responsive>
              <thead>
                <tr>
                  <th>RoomType</th>
                  <th>Room</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Nights</th>
                  <th>Rate/Night</th>
                  <th>Amount</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {reservationRooms.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No rooms
                    </td>
                  </tr>
                ) : (
                  reservationRooms.map((rr) => (
                    <tr key={rr.reservationRoomId}>
                      <td>{rr.roomType?.name || "—"}</td>
                      <td>{rr.room?.roomNumber || "—"}</td>
                      <td>{rr.fromDate ? rr.fromDate.split("T")[0] : "—"}</td>
                      <td>{rr.toDate ? rr.toDate.split("T")[0] : "—"}</td>
                      <td>{rr.nights}</td>
                      <td>
                        {rr.ratePerNight != null
                          ? Number(rr.ratePerNight).toFixed(2)
                          : "—"}
                      </td>
                      <td>
                        {rr.amount != null ? Number(rr.amount).toFixed(2) : "—"}
                      </td>
                      <td>
                        <Button
                          size="sm"
                          variant="outline-danger"
                          onClick={() =>
                            this.deleteReservationRoom(rr.reservationRoomId)
                          }
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          )}

          <hr />

          <h6>Add Room</h6>
          <Row className="mb-2">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Room Type</Form.Label>
                <Form.Select
                  name="roomTypeId"
                  value={roomNew.roomTypeId}
                  onChange={this.handleRoomNewChange}
                >
                  <option value="">-- Select --</option>
                  {roomTypes.map((t) => (
                    <option key={t.roomTypeId} value={t.roomTypeId}>
                      {t.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Rate Plan</Form.Label>
                <Form.Select
                  name="ratePlanId"
                  value={roomNew.ratePlanId}
                  onChange={this.handleRoomNewChange}
                >
                  <option value="">-- Select --</option>
                  {ratePlans.map((rp) => (
                    <option key={rp.ratePlanId} value={rp.ratePlanId}>
                      {rp.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row className="g-2">
            <Col md={3}>
              <Form.Group>
                <Form.Label>From</Form.Label>
                <Form.Control
                  type="date"
                  name="fromDate"
                  value={roomNew.fromDate}
                  onChange={this.handleRoomNewChange}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>To</Form.Label>
                <Form.Control
                  type="date"
                  name="toDate"
                  value={roomNew.toDate}
                  onChange={this.handleRoomNewChange}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Rate Per Night</Form.Label>
                <Form.Control
                  type="number"
                  name="ratePerNight"
                  value={roomNew.ratePerNight}
                  onChange={this.handleRoomNewChange}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Nights</Form.Label>
                <Form.Control
                  type="number"
                  name="nights"
                  value={roomNew.nights}
                  onChange={this.handleRoomNewChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="g-2 mt-2">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  type="number"
                  name="amount"
                  value={roomNew.amount}
                  onChange={this.handleRoomNewChange}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Guest First Name</Form.Label>
                <Form.Control
                  name="guestFirstName"
                  value={roomNew.guestFirstName}
                  onChange={this.handleRoomNewChange}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="d-flex flex-column">
                <div className="mt-1">&nbsp;</div>
                <div>
                  <Button
                    variant="primary"
                    onClick={this.searchAvailability}
                    disabled={availableLoading}
                  >
                    {availableLoading ? "Searching..." : "Search Availability"}
                  </Button>{" "}
                  <Button
                    variant="outline-secondary"
                    onClick={this.autoAllocateByType}
                    disabled={addingRooms || !roomNew.roomTypeId}
                  >
                    {addingRooms ? "Adding..." : "Auto-Allocate by Type"}
                  </Button>
                </div>
              </Form.Group>
            </Col>
          </Row>

          <div className="mt-3">
            <h6>Available Rooms</h6>
            {!availabilitySearched ? (
              <div className="text-muted">
                Use Search Availability to show rooms for the selected type and
                dates.
              </div>
            ) : availableLoading ? (
              <div className="d-flex align-items-center">
                <Spinner animation="border" size="sm" className="me-2" />{" "}
                Searching...
              </div>
            ) : availableRooms.length === 0 ? (
              <div className="text-muted">No available rooms found.</div>
            ) : (
              <Table bordered hover responsive>
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>RoomNumber</th>
                    <th>Floor</th>
                  </tr>
                </thead>
                <tbody>
                  {availableRooms.map((r) => (
                    <tr key={r.roomId}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedRoomIds.has(r.roomId)}
                          onChange={() => this.toggleSelectRoom(r.roomId)}
                        />
                      </td>
                      <td>{r.roomNumber}</td>
                      <td>{r.floor || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
            <div className="mt-2">
              <Button
                variant="success"
                onClick={this.addSelectedRooms}
                disabled={addingRooms || selectedRoomIds.size === 0}
              >
                {addingRooms ? "Adding..." : "Add Selected Rooms"}
              </Button>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={addingRooms}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

/* ---------- Main HotelReservation component with Accordion ---------- */

export default class HotelReservation extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      reservations: [],
      guests: [],
      roomTypes: [],
      ratePlans: [],
      statuses: [],
      loading: false,
      error: null,

      showResModal: false,
      resEditItem: null,

      showRoomsModal: false,
      currentReservationId: null,

      // accordion / room lines caching
      expandedKey: null, // string reservationId currently expanded
      reservationRoomsMap: {}, // { [reservationId]: [rooms] }
      roomsLoadingMap: {}, // { [reservationId]: boolean }
      roomsErrorMap: {}, // { [reservationId]: error string }
    };
  }

  apiUrl = (resource) => {
    const envBase = (process.env.REACT_APP_API || "").replace(/\/+$/, "");
    const base = envBase || `${window.location.origin.replace(/\/+$/, "")}/api`;
    const path = resource.replace(/^\/+/, "");
    const storeId = this.context?.storeId;
    return storeId
      ? `${base}/${path}?storeId=${encodeURIComponent(storeId)}`
      : `${base}/${path}`;
  };

  fetchWithAuth = async (url, opts = {}) => {
    const headers = { ...(opts.headers || {}) };
    if (
      opts.body &&
      !(opts.body instanceof FormData) &&
      !headers["Content-Type"]
    )
      headers["Content-Type"] = "application/json";
    const token = this.context?.authToken;
    if (token) headers["Authorization"] = `Bearer ${token}`;
    return fetch(url, { ...opts, headers });
  };

  componentDidMount() {
    this.loadAllData();
  }

  loadAllData = async () => {
    const storeId = this.context?.storeId;
    if (!storeId) {
      this.setState({ error: "StoreId not found in context." });
      return;
    }

    this.setState({ loading: true, error: null });
    try {
      const endpoints = [
        this.fetchWithAuth(this.apiUrl("HotelReservation")),
        this.fetchWithAuth(this.apiUrl("HotelGuest")),
        this.fetchWithAuth(this.apiUrl("HotelRoomType")),
        this.fetchWithAuth(this.apiUrl("HotelRatePlan")), // or HotelRateType
        this.fetchWithAuth(this.apiUrl("HotelReservationStatus")),
      ];

      const [resRes, guestRes, typeRes, rateRes, statusRes] = await Promise.all(
        endpoints
      );

      const errors = [];
      if (!resRes.ok) errors.push(await safeText(resRes));
      if (!guestRes.ok) errors.push(await safeText(guestRes));
      if (!typeRes.ok) errors.push(await safeText(typeRes));
      if (!rateRes.ok) errors.push(await safeText(rateRes));
      if (!statusRes.ok) errors.push(await safeText(statusRes));

      if (errors.length)
        throw new Error(
          errors.filter(Boolean).join(" | ") || "Failed to load resources"
        );

      const [reservations, guests, roomTypes, ratePlans, statuses] =
        await Promise.all([
          resRes.json(),
          guestRes.json(),
          typeRes.json(),
          rateRes.json(),
          statusRes.json(),
        ]);

      this.setState({ reservations, guests, roomTypes, ratePlans, statuses });
    } catch (err) {
      console.error("Error loading reservation data:", err);
      this.setState({ error: err.message || "Error loading data" });
    } finally {
      this.setState({ loading: false });
    }

    async function safeText(r) {
      try {
        return await r.text();
      } catch {
        return r.statusText || `HTTP ${r.status}`;
      }
    }
  };

  /* Reservation modal handlers */
  openNewReservation = () =>
    this.setState({ showResModal: true, resEditItem: null });
  openEditReservation = (item) =>
    this.setState({ showResModal: true, resEditItem: item });
  closeReservationModal = () =>
    this.setState({ showResModal: false, resEditItem: null });

  handleReservationSave = async (payload, isEdit) => {
    const storeId = this.context?.storeId;
    if (!storeId) throw new Error("StoreId not found in context.");

    const url =
      isEdit && this.state.resEditItem
        ? `${this.apiUrl(`HotelReservation`)}/${
            this.state.resEditItem.reservationId
          }?storeId=${encodeURIComponent(storeId)}`
        : this.apiUrl("HotelReservation");

    const res = await this.fetchWithAuth(url, {
      method: isEdit ? "PUT" : "POST",
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const txt = await res.text().catch(() => res.statusText);
      throw new Error(txt || `HTTP ${res.status}`);
    }
    this.closeReservationModal();
    await this.loadAllData();
  };

  handleReservationDelete = async (id) => {
    const storeId = this.context?.storeId;
    if (!storeId) {
      this.setState({ error: "StoreId not found." });
      return;
    }
    if (!window.confirm("Delete reservation?")) return;
    try {
      const res = await this.fetchWithAuth(
        `${this.apiUrl("HotelReservation")}/${id}?storeId=${encodeURIComponent(
          storeId
        )}`,
        { method: "DELETE" }
      );
      if (!res.ok) {
        const txt = await res.text().catch(() => res.statusText);
        throw new Error(`${res.status} ${txt}`);
      }
      // clear cached rooms for deleted reservation
      this.setState((s) => {
        const map = { ...s.reservationRoomsMap };
        delete map[id];
        return { reservationRoomsMap: map };
      });
      await this.loadAllData();
    } catch (err) {
      console.error("handleReservationDelete", err);
      this.setState({ error: err.message || "Failed to delete reservation." });
    }
  };

  /* Rooms modal handlers (show separate modal if wanted) */
  openRoomsModal = (reservationId) => {
    this.setState({
      showRoomsModal: true,
      currentReservationId: reservationId,
    });
  };
  closeRoomsModal = () =>
    this.setState({ showRoomsModal: false, currentReservationId: null });

  handleRoomsChanged = async () => {
    // clear cached rooms so accordion will refresh on next open
    this.setState({ reservationRoomsMap: {} });
    await this.loadAllData();
  };

  /* Accordion expansion: lazy load reservation rooms for an item */
  onAccordionToggle = async (eventKey) => {
    // eventKey is reservationId string or null; if null collapse
    this.setState({ expandedKey: eventKey || null });
    const reservationId = eventKey;
    if (!reservationId) return;

    // if we already have it cached, no need to reload
    if (this.state.reservationRoomsMap[reservationId]) return;

    // set loading flag
    this.setState((s) => ({
      roomsLoadingMap: { ...s.roomsLoadingMap, [reservationId]: true },
      roomsErrorMap: { ...s.roomsErrorMap, [reservationId]: null },
    }));
    try {
      const url = this.apiUrl(`HotelReservation/${reservationId}/rooms`);
      const res = await this.fetchWithAuth(url);
      if (!res.ok) {
        const txt = await res.text().catch(() => res.statusText);
        throw new Error(`${res.status} ${txt}`);
      }
      const rooms = await res.json();
      this.setState((s) => ({
        reservationRoomsMap: {
          ...s.reservationRoomsMap,
          [reservationId]: rooms,
        },
      }));
    } catch (err) {
      console.error("load rooms for reservation", err);
      this.setState((s) => ({
        roomsErrorMap: {
          ...s.roomsErrorMap,
          [reservationId]: err.message || "Failed to load rooms",
        },
      }));
    } finally {
      this.setState((s) => ({
        roomsLoadingMap: { ...s.roomsLoadingMap, [reservationId]: false },
      }));
    }
  };

  /* Helper to render rooms list inside accordion body */
  renderRoomsForReservation = (reservationId) => {
    const rooms = this.state.reservationRoomsMap[reservationId] || [];
    const loading = this.state.roomsLoadingMap[reservationId];
    const error = this.state.roomsErrorMap[reservationId];

    if (loading)
      return (
        <div className="d-flex align-items-center">
          <Spinner animation="border" size="sm" className="me-2" /> Loading
          rooms...
        </div>
      );
    if (error) return <Alert variant="danger">{error}</Alert>;

    return (
      <Table bordered size="sm" responsive>
        <thead>
          <tr>
            <th>RoomType</th>
            <th>Room</th>
            <th>From</th>
            <th>To</th>
            <th>Nights</th>
            <th>Rate/Night</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {rooms.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center">
                No rooms
              </td>
            </tr>
          ) : (
            rooms.map((rr) => (
              <tr key={rr.reservationRoomId}>
                <td>{rr.roomType?.name || "—"}</td>
                <td>{rr.room?.roomNumber || "—"}</td>
                <td>{rr.fromDate ? rr.fromDate.split("T")[0] : "—"}</td>
                <td>{rr.toDate ? rr.toDate.split("T")[0] : "—"}</td>
                <td>{rr.nights}</td>
                <td>
                  {rr.ratePerNight != null
                    ? Number(rr.ratePerNight).toFixed(2)
                    : "—"}
                </td>
                <td>
                  {rr.amount != null ? Number(rr.amount).toFixed(2) : "—"}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    );
  };

  render() {
    const {
      reservations,
      guests,
      roomTypes,
      ratePlans,
      statuses,
      loading,
      error,
      showResModal,
      resEditItem,
      showRoomsModal,
      currentReservationId,
      expandedKey,
    } = this.state;

    return (
      <div className="container mt-4">
        <Row className="mb-3 align-items-center">
          <Col>
            <h4>Hotel Reservations</h4>
          </Col>
          <Col className="text-end">
            <Button onClick={this.openNewReservation} disabled={loading}>
              New Reservation
            </Button>
          </Col>
        </Row>

        {error && <Alert variant="danger">{error}</Alert>}

        {loading ? (
          <div className="d-flex align-items-center">
            <Spinner animation="border" size="sm" className="me-2" /> Loading...
          </div>
        ) : (
          <Accordion activeKey={expandedKey} onSelect={this.onAccordionToggle}>
            {reservations.length === 0 && (
              <div className="text-center text-muted mb-3">No reservations</div>
            )}
            {reservations.map((r) => (
              <Accordion.Item eventKey={r.reservationId} key={r.reservationId}>
                <Accordion.Header>
                  <div className="d-flex justify-content-between w-100">
                    <div>
                      <strong>{r.reservationNo || "—"}</strong>{" "}
                      <span className="text-muted">
                        {" "}
                        —{" "}
                        {r.guest
                          ? `${r.guest.firstName || ""} ${
                              r.guest.lastName || ""
                            }`
                          : "No guest"}
                      </span>
                    </div>
                    <div className="text-end" style={{ minWidth: 300 }}>
                      <small className="me-3">
                        Arrival:{" "}
                        {r.arrivalDate ? r.arrivalDate.split("T")[0] : "—"}
                      </small>
                      <small className="me-3">
                        Departure:{" "}
                        {r.departureDate ? r.departureDate.split("T")[0] : "—"}
                      </small>
                      <small className="me-3">Rooms: {r.numRooms}</small>
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        className="me-1"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.openEditReservation(r);
                        }}
                      >
                        Edit
                      </Button>
                      <Button
                        size="sm"
                        variant="outline-info"
                        className="me-1"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.openRoomsModal(r.reservationId);
                        }}
                      >
                        Rooms
                      </Button>
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.handleReservationDelete(r.reservationId);
                        }}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <Row className="mb-2">
                    <Col md={8}>
                      <div>
                        <strong>Notes:</strong> {r.notes || "—"}
                      </div>
                      <div className="text-muted mt-1">
                        Created:{" "}
                        {r.createdAt
                          ? new Date(r.createdAt).toLocaleString()
                          : "—"}
                      </div>
                    </Col>
                    <Col md={4} className="text-end">
                      <div>
                        <strong>Status:</strong> {r.status?.code || "—"}
                      </div>
                      <div>
                        <strong>Guests:</strong> {r.numGuests}
                      </div>
                      <div>
                        <strong>Amount:</strong>{" "}
                        {r.totalAmount != null
                          ? Number(r.totalAmount).toFixed(2)
                          : "—"}
                      </div>
                    </Col>
                  </Row>

                  <h6>Reserved Rooms</h6>
                  {this.renderRoomsForReservation(r.reservationId)}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        )}

        <ReservationModal
          show={showResModal}
          onClose={this.closeReservationModal}
          onSave={this.handleReservationSave}
          item={resEditItem}
          guests={guests}
          statuses={statuses}
          storeId={this.context?.storeId}
        />

        <RoomsModal
          show={showRoomsModal}
          onClose={this.closeRoomsModal}
          reservationId={currentReservationId}
          roomTypes={roomTypes}
          ratePlans={ratePlans}
          apiUrl={this.apiUrl}
          fetchWithAuth={this.fetchWithAuth}
          onAdded={this.handleRoomsChanged}
        />
      </div>
    );
  }
}
